import {Component, inject, OnInit} from '@angular/core';
import {ControlContainer, FormArray, UntypedFormGroup as FormGroup} from "@angular/forms";
import {DialogRef} from "@fundamental-ngx/core/dialog";
import {PAYLOAD_FORM_CONTROLS, PAYLOAD_FORM_GROUPS} from "../unified-create-suite-dialog.component";
import {Const} from "../../../../../core/helpers/Const";
import {STEP_SETUP_FORM_CONTROLS, STEP_SETUP_FORM_GROUPS } from '../unified-suite-step-setup/unified-suite-step-setup.component';

@Component({
    selector: 'app-unified-suite-step-review',
    templateUrl: './unified-suite-step-review.component.html',
    styleUrls: ['./unified-suite-step-review.component.scss'],
    standalone: false
})
export class UnifiedSuiteStepReviewComponent implements OnInit {
    readonly STEP_SETUP_FORM_GROUPS = STEP_SETUP_FORM_GROUPS;
    readonly STEP_SETUP_FORM_CONTROLS = STEP_SETUP_FORM_CONTROLS;
    readonly PAYLOAD_FORM_GROUPS = PAYLOAD_FORM_GROUPS;
    readonly PAYLOAD_FORM_CONTROLS = PAYLOAD_FORM_CONTROLS;
    readonly Const = Const;
    readonly dialogRef = inject(DialogRef);
    readonly controlContainer = inject(ControlContainer);
    readonly BASE_PLACEHOLDER = "Enter a value";

    public form: FormGroup;
    public path: string;

    get businessTypes(): FormArray {
        return this.form
            ?.get(STEP_SETUP_FORM_GROUPS.STEP_SETUP)?.get(STEP_SETUP_FORM_CONTROLS.BUSINESS_TYPES) as FormArray;
    }

    readonly CUSTOM_VALIDATION_ERRORS = {
        RESOURCE_TYPE_DEFINITION: {
            GROUP: "Invalid input. The value can contain only lowercase alphabetical letters (a-z), numbers (0-9), hyphens (-), and periods (.). It must start and end with a lowercase letter or number.",
            VERSION: "Invalid input. The value can contain only lowercase alphabetical letters (a-z), numbers (0-9), and hyphens (-). It must start with a lowercase letter, and end with either a lowercase letter or number.",
            TYPE: "Invalid input. The value can contain only lowercase and uppercase alphabetical letters (a-z, A-Z). It must start with an uppercase letter (A-Z).",
            SINGULAR_PLURAL: "Invalid input. The value can contain only lowercase alphabetical letters (a-z)."
        }
    };

    ngOnInit(): void {
        this.form = <FormGroup>this.controlContainer.control;
        this.path = this.dialogRef.data.path;
    }
}
